export default __webpack_public_path__ + "static/media/contact-us-icon.e6fc39fd.svg";